import { styled } from "../../../theme";
import { Text } from "../../../text";
export const Radio = styled.svg `
  width: 1.375em;
  height: 1.375em;
  // Hack: min- values are required for flexbox sizing https://github.com/philipwalton/flexbugs/issues/184
  min-width: 1.375em;
  max-height: 1.375em;

  ${({ disabled }) => disabled && "cursor: not-allowed;"}
`;
export const StyledText = styled(Text) `
  padding-left: 1.5em;
  pointer-events: none;
  font-size: 1.25em;
  line-height: 1.5em;
  font-weight: ${({ theme }) => theme.fontWeight.normal};

  a {
    pointer-events: auto;
  }
`;
export const HelperLabel = styled(Text) `
  display: block;
  pointer-events: none;
  font-size: ${({ theme }) => theme.fontSize[2]}px;
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  color: ${({ theme }) => theme.color.gray150};
`;
export const OuterCircle = styled.circle `
  stroke-width: 0.125rem;
  stroke: ${({ theme, disabled }) => disabled ? theme.color.gray100 : theme.color.primary};
  fill: transparent;
`;
export const InnerCircle = styled.circle `
  stroke: transparent;
  fill: ${({ checked, disabled, theme }) => disabled
    ? theme.color.gray100
    : checked
        ? theme.color.primary
        : "transparent"};
  visibility: ${({ checked }) => (checked ? "visible" : "hidden")};
`;
